import React from "react";
import StackedBarChart from "../Charts/StackedBarChart";
import { getEmailTrends, getClickTrends } from "../Insights/actions";

function Insights(props: any) {
  const { tab } = props;
  return (
    <div>
      {tab === "" || tab === "/" || tab === undefined ? (
        <StackedBarChart getTrends={getEmailTrends} />
      ) : tab === "clickTrends" ? (
        <StackedBarChart getTrends={getClickTrends} />
      ) : null}
    </div>
  );
}

export default Insights;
